"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WithShortcut = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const KeyLite_1 = require("../../1-inline/KeyLite");
const slotClass = (0, nano_theme_1.rule)({
    pos: 'relative',
    d: 'inline-block',
});
const badgeClass = (0, nano_theme_1.rule)({
    pos: 'absolute',
    t: '-6px',
    r: '4px',
});
const WithShortcut = ({ shortcut, small = true, hidden, badgeStyle, badgeProps, className, children, }) => {
    return (React.createElement("span", { className: slotClass + (className ? ' ' + className : '') },
        children,
        !hidden && (React.createElement(KeyLite_1.KeyLite, { ...badgeProps, small: small, className: badgeClass, style: badgeStyle }, shortcut))));
};
exports.WithShortcut = WithShortcut;
